export const API_URL = "https://0jicayvun7.execute-api.us-east-2.amazonaws.com";
// Sun Jul  5 11:36:51 EDT 2026
